<template>
  <div class="wrap">
    <NavBar :title="$t('额度转换')" />
    <div class="wrap_cont">
      <div class="wallet_grid">
        <div class="wallet_card" :class="[active == 0 && 'wallet_active']" @click="activeClick(0)">
          <span>{{ $t('余额') }}{{ $t('钱包') }}</span>
          <strong>{{ $money(userInfo.money || '0.00') }}</strong>
          <em>{{ $t('转为') }}USDT</em>
        </div>
        <div class="wallet_card" :class="[active == 1 && 'wallet_active']" @click="activeClick(1)">
          <span>USDT{{ $t('钱包') }}</span>
          <strong>{{ Number(userInfo.usdt) || '0.00' }} USDT</strong>
          <em>{{ $t('转为') }}{{ $t('余额') }}</em>
        </div>
      </div>
      <div class="direction_card">
        <div class="direction_row">
          <div class="row_item">
            <span>{{ $t('转出') }}</span>
            <template v-if="active == 1">
              <strong>USDT{{ $t('钱包') }}</strong>
              <em>{{ Number(userInfo.usdt) || '0.00' }} USDT</em>
            </template>
            <template v-if="active == 0">
              <strong>{{ $t('余额') }}{{ $t('钱包') }}</strong>
              <em>{{ $money(userInfo.money || '0.00') }}</em>
            </template>
          </div>
          <div class="icon" @click="exchange">
            <van-icon name="exchange" color="#31e2a5" size="24" />
          </div>
          <div class="row_item">
            <span>{{ $t('转入') }}</span>
            <template v-if="active == 0">
              <strong>USDT{{ $t('钱包') }}</strong>
              <em>{{ Number(userInfo.usdt) || '0.00' }} USDT</em>
            </template>
            <template v-if="active == 1">
              <strong>{{ $t('余额') }}{{ $t('钱包') }}</strong>
              <em>{{ $money(userInfo.money || '0.00') }}</em>
            </template>
          </div>
        </div>
        <div class="input">
          <van-field v-model="money" :placeholder="$t('请输入要转换的金额')" />
          <div class="all" @click="all">{{ $t('all') }}</div>
        </div>
        <div class="rate">
          1 USDT = {{ usdtCurrency.rate }} INR
        </div>
        <div class="btn" @click="exchangeSubmit">{{ $t('确认转换') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/JNav";
import { Icon, Field, Toast } from "vant"
import { mapGetters } from "vuex";
import { USERS_MONEY_CONVERT } from "@/api"
export default {
  components: {
    NavBar,
    [Icon.name]: Icon,
    [Field.name]: Field,
    Toast
  },
  data() {
    return {
      active: 0,
      money: '',
      usdtCurrency: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.getNotice();
    this.$store.dispatch("getuserInfo");
  },
  methods: {
    getNotice() {
      this.$api.getNotice((res) => {
        this.usdtCurrency = res.currencys.find(item => item.code == 'usdt');
      });
    },
    activeClick(index) {
      if (this.active == index) return;
      this.active = index;
      this.money = ''
    },
    exchange() {
      this.money = ''
      if (this.active == 0) {
        this.active = 1;
      } else {
        this.active = 0;
      }
    },
    all() {
      if (this.active == 0) {
        this.money = this.userInfo.money;
      } else {
        this.money = Number(this.userInfo.usdt) || '0.00'
      }
    },
    async exchangeSubmit() {

      if (!Number.isFinite(Number(this.money))) return;
      console.log(Number.isFinite(Number(this.money)), this.money);
      if (!this.money || this.money == 0) return;
      try {
        const res = await USERS_MONEY_CONVERT({
          direction: this.active == 0 ? 'money_to_usdt' : 'usdt_to_money',
          amount: this.money
        })
        console.log(res);
        Toast(res.msg)
        setTimeout(() => {
          this.$store.dispatch("getuserInfo");
          this.money = ''
        }, 500)
      } catch (error) {
        Toast(error.msg);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: calc(100vh - 18px);
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);
  padding: 0 0 18px;

  .wrap_cont {
    padding: 18px 16px 0;

    .wallet_grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;

      .wallet_card {
        display: grid;
        gap: 8px;
        padding: 16px 14px;
        border: 1px solid #e7e7e7;
        border-radius: 10px;
        background: #fff;
        color: #2f3136;

        span {
          color: #7a8597;
          font-size: 14px;
          font-weight: 800;
        }

        strong {
          color: #2f3136;
          font-size: 18px;
          font-weight: 950;
          word-break: break-word;
        }

        em {
          color: #31e2a5;
          font-style: normal;
          font-size: 13px;
          font-weight: 850;
          line-height: 1;
        }
      }

      .wallet_active {
        border-color: #31e2a5;
        background: #f0fffa;
      }
    }

    .direction_card {
      display: grid;
      gap: 14px;
      padding: 16px;
      border-radius: 10px;
      background: #fff;
      margin-top: 10px;

      .direction_row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 44px minmax(0, 1fr);
        align-items: center;
        gap: 12px;

        .icon {
          display: grid;
          width: 44px;
          height: 44px;
          place-items: center;
          border: 0;
          border-radius: 999px;
          background: #e8fbf5;
        }

        .row_item {
          display: grid;
          min-width: 0;
          gap: 5px;

          span {
            color: #7a8597;
            font-size: 14px;
            font-weight: 800;
          }

          strong {
            color: #2f3136;
            font-size: 18px;
            font-weight: 950;
            word-break: break-word;
          }

          em {
            color: #31e2a5;
            font-style: normal;
            font-size: 13px;
            font-weight: 850;
            line-height: 1;
          }
        }
      }

      .input {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
        min-height: 48px;
        padding: 0 14px;
        border: 1px solid #e4e4e4;
        border-radius: 10px;
        background: #fff;
        color: #2f3136;
        font-size: 22px;
        font-weight: 900;
        gap: 10px;

        :deep(.van-field) {
          padding: 0;
        }

        .all {
          color: #31e2a5;
          font-size: 18px;
          font-weight: 600;
        }
      }

      .rate {
        background: #eef8ff;
        color: #3f83ed;
        padding: 10px 12px;
        border-radius: 10px;
        line-height: 1.45;
        font-size: 14px;
        font-weight: 850;
      }

      .btn {
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        box-shadow: 0 9px 20px #31e2a547;
        color: #064b38;
        font-weight: 800;
        height: 54px;
        border-radius: 8px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>